import React from 'react';

const MailboxSticker = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 140 170"
    width="120"
    height="146"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <ellipse cx="70" cy="160" rx="42" ry="7" fill="#2A2D34" opacity="0.1" />

    {/* post */}
    <rect x="63" y="96" width="14" height="60" rx="2" fill="#8A6A52" />
    <rect x="63" y="96" width="6" height="60" fill="#6E5340" />
    <rect x="52" y="150" width="36" height="10" rx="2" fill="#6E5340" />

    {/* box body */}
    <path
      d="M20 66 C20 46 34 34 70 34 C106 34 120 46 120 66 L120 96 C120 100 116.4 103 112 103 L28 103 C23.6 103 20 100 20 96 Z"
      fill="#2C4A7C"
    />
    {/* box top highlight */}
    <path
      d="M20 66 C20 46 34 34 70 34 L70 103 L28 103 C23.6 103 20 100 20 96 Z"
      fill="#3B62A0"
    />
    <path
      d="M20 66 C20 46 34 34 70 34 L70 40 C38 40 26 50 26 66 Z"
      fill="#5B84C4"
      opacity="0.7"
    />

    {/* door */}
    <rect x="94" y="52" width="22" height="40" rx="3" fill="#1F3B66" />
    <rect x="94" y="52" width="22" height="40" rx="3" fill="none" stroke="#132747" strokeWidth="1.5" />
    <circle cx="100" cy="72" r="2" fill="#9FB8DE" />

    {/* mail slot + peeking envelope */}
    <rect x="34" y="58" width="30" height="7" rx="2" fill="#132747" />
    <path d="M30 58 L44 70 L58 58 Z" fill="#F3ECDE" />
    <rect x="30" y="52" width="28" height="10" rx="1.5" fill="#F3ECDE" />
    <path d="M30 52 L44 62 L58 52 Z" fill="#E4D9BF" />

    {/* flag */}
    <rect x="112" y="30" width="4" height="26" rx="1.5" fill="#8A6A52" />
    <path d="M116 32 L134 38 L116 44 Z" fill="#B3413E" />

    {/* base plate under box */}
    <rect x="20" y="96" width="100" height="7" rx="3" fill="#193458" />

    {/* little heart detail on the door */}
    <path
      d="M105 80 C103.5 78.3 101 78.6 100.4 80.6 C99.8 78.6 97.3 78.3 95.8 80 C94.3 81.7 95.6 84.3 100.4 87.4 C105.2 84.3 106.5 81.7 105 80 Z"
      fill="#9FB8DE"
      opacity="0.85"
    />
  </svg>
);

export default MailboxSticker;
